// removed by extract-text-webpack-plugin
module.exports = {"divider":"src-pages----contact-module---divider---CU_GG","paragraph":"src-pages----contact-module---paragraph---Wy51y","icon":"src-pages----contact-module---icon---Nv6u0","link":"src-pages----contact-module---link---w7c1G","item":"src-pages----contact-module---item---25FKe","image":"src-pages----contact-module---image---2IKYU"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/contact.module.css
// module id = 429
// module chunks = 70144966829960